import { Component, OnInit } from "@angular/core";
import {
  AdmissionReceptionWizardService,
  AdmissionWizardService,
} from "../../../services/wizard/admission/admission.wizzard.service";
import { PatientSearch } from "../../../model/patient/patient-search";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { WizardStep } from "../../../wizard/wizard.component";
import "rxjs/add/observable/of";
import { PatientView } from "../../../model/patient/patient-view";
import { PatientService } from "../../../services/patient.service";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { MatDialog } from "@angular/material";
import { PatientEditDialogComponent } from "../../dialogs/patient-edit/patient-edit-dialog.component";
import {
  patientValidator,
  patientViewValidator,
} from "src/app/validators/patient/patient.validator";

@Component({
  selector: "app-admission-patient-component",
  templateUrl: "./admission-patient.component.html",
  styleUrls: ["./admission-patient.component.css"],
})
export class AdmissionPatientComponent implements OnInit, WizardStep {
  isInit: boolean;
  formGroup: FormGroup;
  patient: PatientView;
  loading: boolean;
  invalidViewResultWeb: boolean;

  constructor(
    private admissionWizardService: AdmissionWizardService,
    private notificationToastService: NotificationToastService,
    private patientService: PatientService,
    private formBuilder: FormBuilder
  ) {
    this.formGroup = this.formBuilder.group({
      Patient: [null, [Validators.required, patientViewValidator]],
    });
  }

  get readOnly(): boolean {
    return this.admissionWizardService.isReadOnly();
  }
  get isWizard(): boolean {
    return !this.admissionWizardService.isWizzard();
  }
  get completed(): boolean {
    return !this.formGroup.invalid;
  }
  get valid(): boolean {
    return this.completed;
  }

  get f() {
    return this.formGroup.controls;
  }

  save() {
    if (!this.formGroup.invalid) {
      this.admissionWizardService.setPatient(
        <PatientView>this.formGroup.getRawValue().Patient
      );
    }
  }

  onPatientChange(patientView: PatientView) {
    this.patient = patientView;
    this.formGroup.patchValue({ Patient: this.patient });
  }

  async onPatientSelected(patientSearch: PatientSearch) {
    try {
      this.loading = true;
      this.patient = await this.patientService.getPatientView(patientSearch.Id);
      this.formGroup.patchValue({ Patient: this.patient });
      this.loading = false;
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión"
      );
    } finally {
      this.loading = false;
    }
  }

  async activate() {
    try {
      if (this.isInit) {
        this.loading = true;
        this.patient = await this.admissionWizardService.getPatient();
        this.formGroup.patchValue({ Patient: this.patient });
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión"
      );
    } finally {
      this.loading = false;
    }
  }

  edit(): void {}

  async ngOnInit() {
    this.isInit = true;
  }
}
